









import { Prop, Component, Vue } from "vue-property-decorator";

// CSSと紐づけるので共通化せずに定義する
const variantOptions = ["保留", "未着工", "施工前", "施工中", "施工終了"];

const sizeOptions = ["sm", "md"];

@Component({})
export default class ProjectStatus extends Vue {
  @Prop({
    required: true,
    type: String,
    validator: s => variantOptions.includes(s)
  })
  variant!: string;

  @Prop({
    default: "md",
    type: String,
    validator: s => sizeOptions.includes(s)
  })
  size!: string;

  get className() {
    return [`ProjectStatus-${this.size}`, `ProjectStatus--${this.variant}`];
  }
}
